import { computeChartModel } from "./celestine-adapter.js";
import { drawRadix } from "./astrochart-bridge.js";

export async function runPipeline(birth, targets) {
  const model = computeChartModel(birth);

  if (targets.chartEl) {
    await drawRadix(targets.chartEl, model);
  }

  if (targets.positionsEl) {
    targets.positionsEl.innerHTML = renderPositionsTable(model);
  }

  if (targets.aspectsEl) {
    targets.aspectsEl.innerHTML = renderAspectsTable(model);
  }

  return model;
}

function renderPositionsTable(model) {
  const rows = [
    ...model.bodies.map((b) => positionRow(b)),
    ...model.angles.map((a) => positionRow(a, true)),
  ];

  return `
    <table class="data-table">
      <thead>
        <tr>
          <th scope="col">Body</th>
          <th scope="col">Position</th>
          <th scope="col">Sign</th>
          <th scope="col">House</th>
          <th scope="col">Rx</th>
        </tr>
      </thead>
      <tbody>
        ${rows.join("")}
      </tbody>
    </table>
  `;
}

function renderAspectsTable(model) {
  const majors = new Set([
    "conjunction",
    "sextile",
    "square",
    "trine",
    "opposition",
  ]);

  const list = model.aspects
    .filter((a) => majors.has(String(a.type).toLowerCase()))
    .slice(0, 40);

  if (!list.length) {
    return `<p class="table-empty">No major aspects returned.</p>`;
  }

  const rows = list
    .map(
      (a) => `
      <tr>
        <td>${escapeHtml(prettyBody(a.body1))}</td>
        <td class="aspect-type">${escapeHtml(a.type)}</td>
        <td>${escapeHtml(prettyBody(a.body2))}</td>
        <td class="num">${Number(a.orb).toFixed(2)}°</td>
      </tr>`
    )
    .join("");

  return `
    <table class="data-table">
      <thead>
        <tr>
          <th scope="col">Body</th>
          <th scope="col">Aspect</th>
          <th scope="col">Body</th>
          <th scope="col">Orb</th>
        </tr>
      </thead>
      <tbody>
        ${rows}
      </tbody>
    </table>
  `;
}

function prettyBody(name) {
  return String(name)
    .replace(/^True\s+/i, "")
    .replace(/^Mean\s+/i, "");
}

function positionRow(b, isAngle = false) {
  const house = b.house != null && !isAngle ? String(b.house) : "—";
  const rx = b.isRetrograde ? "R" : "";
  const cls = isAngle ? "angle-row" : "";
  return `
    <tr class="${cls}">
      <td>${escapeHtml(b.name)}</td>
      <td class="num">${escapeHtml(formatDms(b))}</td>
      <td>${escapeHtml(b.signName || "")}</td>
      <td class="num">${escapeHtml(house)}</td>
      <td class="rx">${rx}</td>
    </tr>`;
}

function formatDms(b) {
  if (b.degree != null && b.minute != null) {
    return `${pad2(Math.floor(b.degree))}°${pad2(Math.floor(b.minute))}'`;
  }
  const lon = ((b.longitude % 30) + 30) % 30;
  const d = Math.floor(lon);
  const m = Math.floor((lon - d) * 60);
  return `${pad2(d)}°${pad2(m)}'`;
}

function pad2(n) {
  return String(n).padStart(2, "0");
}

function escapeHtml(s) {
  return String(s)
    .replace(/&/g, "&" + "amp;")
    .replace(/</g, "&" + "lt;")
    .replace(/>/g, "&" + "gt;")
    .replace(/"/g, "&" + "quot;");
}
